const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const authEndpoints = {
	REGISTER_API: BASE_URL + "/customer-register",
	LOGIN_API: BASE_URL + "/login",
	Registration_OTP_API: BASE_URL + "/verify-otp",
	VERIFY_LOGIN_API: BASE_URL + "/verify-login",
	// VERIFY_LOGIN_API: BASE_URL + "/verify-login",
};

export const userEndpoints = {
	UPDATE_PROFILE_API: BASE_URL + "/update-profile",
	GET_USER_DETAILS_API: BASE_URL + "/user-details",
	UPDATE_PERSONAL_DETAILS: BASE_URL + "/update-personal-details",
	UPDATE_EDUCATION_DETAILS: BASE_URL + "/update-education-details",
	UPDATE_FAMILY_DETAILS: BASE_URL + "/update-family-details",
	UPDATE_PARTNER_DETAILS: BASE_URL + "/update-partner-details",
	GET_PROFILE_API: BASE_URL + "/profile",
	GET_HEALTH_CONDITION_LIST: BASE_URL + "/admin-settings/healthconditionList"
};

export const adminEndpoints = {
	GET_CITIES_LIST: BASE_URL + "/admin-settings/cityList",
	GET_RELIGIONS_LIST: BASE_URL + "/admin-settings/religionList",
	GET_CASTES_LIST: BASE_URL + "/admin-settings/castList",
	GET_MUSIC_LIST: BASE_URL + "/admin-settings/musicList",
	GET_HOBBIES_LIST: BASE_URL + "/admin-settings/hobbiesList",
	GET_EDUCATION_LIST: BASE_URL + "/admin-settings/educationList",
	GET_UNIVERSITIES_LIST: BASE_URL + "/admin-settings/universitiesList",
	GET_PROFESSION_LIST: BASE_URL + "/admin-settings/professionList",
	GET_DESIGNATION_LIST: BASE_URL + "/admin-settings/designationList",
	GET_FAMILY_STATUS_LIST: BASE_URL + "/admin-settings/familystatusList",
	GET_FAMILY_TYPE_LIST: BASE_URL + "/admin-settings/familytypeList",
	GET_LOOKING_FOR_LIST: BASE_URL + "/admin-settings/lookingforList",
	GET_MOTHER_TONGUE_LIST: BASE_URL + "/admin-settings/mothertongueList",
	GET_STAR_LIST: BASE_URL + "/admin-settings/starList",
	GET_MOONSIGN_LIST: BASE_URL + "/admin-settings/moonsignList",
	GET_INTERESTS_LIST: BASE_URL + "/admin-settings/interestsList",
	GET_CUISINE_LIST: BASE_URL + "/admin-settings/cuisineList",
	GET_READS_LIST: BASE_URL + "/admin-settings/readsList",
	GET_SPORTS_LIST: BASE_URL + "/admin-settings/sportsList",
	GET_MOVIES_LIST: BASE_URL + "/admin-settings/moviesList",
	GET_DRESS_STYLE_LIST: BASE_URL + "/admin-settings/dressstyleList",
	GET_LANGUAGE_LIST: BASE_URL + "/admin-settings/languageList",
	GET_APPLICATION_FOR_LIST: BASE_URL + "/admin-settings/applicationforList",
	GET_SOURCE_LIST: BASE_URL + "/admin-settings/sourceList",
	GET_EMPLOYEDIN_LIST: BASE_URL + "/admin-settings/employedinList",
	GET_COUNTRIES_LIST: BASE_URL + "/admin-settings/countryList",
	GET_STATES_LIST: BASE_URL + "/admin-settings/statesList",
	GET_DISTRICTS_LIST: BASE_URL + "/admin-settings/districtsList",
	GET_HEALTH_CONDITION_LIST: BASE_URL + "/admin-settings/healthconditionList",
	GET_SUBCASTES_LIST:BASE_URL +"/admin-settings/getSubCastList",
	GET_STATES_LIST_BY_COUNTRY: BASE_URL + "/admin-settings/statesList",
	GET_DISTRICTS_LIST_BY_STATE: BASE_URL + "/admin-settings/districtsList",
	GET_CITIES_LIST_BY_DISTCT: BASE_URL + "/admin-settings/cityList",
	GET_RELATION_LIST: BASE_URL +  "/admin-settings/relationList",
	GET_VISA_TYPES : BASE_URL + "/admin-settings/VisaTypes"


};

export const customerEndpoints = {
	GET_NEAREST_BRANCH_LIST: BASE_URL + "/customer/nearestBranchList",
};

export const matrimoneyEndPoints = {
	VIEW_CUSTOMER_DETAILS : BASE_URL + "/matrimony/profile-details",
	GET_ROLE_LIST:BASE_URL + "/admin-settings/roleList",
	GET_CONTACTUS_BRANCH_LIST: BASE_URL +"/contactUs",
	GET_ADVANCED_LIST:BASE_URL +"/matrimony/advanceProfiles",
	UPLOAD_STAFF_DOCUMNENTS:BASE_URL + "/user-management/career-certificates-upload",
	GET_CREATE_STAFF:BASE_URL + "/user-management/career",
	GET_IDSEARCH_LIST:BASE_URL + "/matrimony/id-search",
	GET_ACCEPT:BASE_URL+ "/matrimony/accept-interest",
	GET_IGNORE:BASE_URL + "/matrimony/ignore-interest",
	GET_QUICK_SEARCH:BASE_URL+"/matrimony/quickProfiles",
	UPCOMING_PROFILES_DATA : BASE_URL + "/matrimony/upcoming-profiles",
	VERIFIED_PROFILES_DATA : BASE_URL + "/matrimony/verified-profiles",
	COMMUNITY_PROFILES_DATA : BASE_URL + "/matrimony/community-profiles",
	MATCHED_PROFILES_DATA : BASE_URL + "/matrimony/matched-profiles",
	PROFILES_I_VIEWED : BASE_URL + "/matrimony/profiles-i-viewed",
	VIEWED_MY_PROFILE : BASE_URL + "/matrimony/viewed-my-profile",
	SHORT_LISTED_PROFILE : BASE_URL + "/matrimony/short-listed-profiles",
	BLOCK_LISTED_PROFILE : BASE_URL + "/matrimony/blocked-listed-profiles",
	UPLOAD_PROFILE_PICS : BASE_URL + "/matrimony/upload-gallery",
	GET_UPLOAD_IMAGES : BASE_URL + "/matrimony/getCustomerAlbum",
	INTEREST_SENT_PROFILES_LIST : BASE_URL + "/matrimony/interest-sent-profiles-list",
	INTEREST_ACCEPTED_PROFILES_LIST : BASE_URL + "/matrimony/interest-acceped-profiles-list",
	INTEREST_IGNORED_PROFILES_LIST : BASE_URL + "/matrimony/interest-ignored-profiles-list",
	INTEREST_PENDING_PROFILES_LIST : BASE_URL + "/matrimony/interest-pending-profiles-list",
	INTEREST_RECEIVED_PROFILES_LIST : BASE_URL + "/matrimony/interests-received-profiles-list",
	INTEREST_VIEWED_PROFILES_LIST : BASE_URL + "/matrimony/interest-viewed-profiles-list",
	SEND_INTEREST : BASE_URL + "/matrimony/send-interest",
	SHORT_LIST_PROFILE : BASE_URL + "/matrimony/short-list-profile",
	BLOCK_LIST_PROFILE : BASE_URL + "/matrimony/block-profile",
	INTEREST_COUNTS : BASE_URL + "/matrimony/interest-counts",
	PROFILE_COUNTS : BASE_URL + "/matrimony/profile-counts",
	CUSTOMER_PLANS : BASE_URL + "/customer-plans",
	CREATE_ORDER : BASE_URL + "/matrimony/create-order",
	VERIFY_PAYMENT : BASE_URL + "/matrimony/verify-payment",
	MY_PROFILE_CARD : BASE_URL + "/matrimony/my-profile-card",
	UPDATE_PERSONAL_DETAILS : BASE_URL + "/matrimony/updatePersonalDetails",
	UPDATE_EDUCATION_DETAILS : BASE_URL + "/matrimony/updateEducationalDetails",
	UPDATE_FAMILY_DETAILS : BASE_URL + "/matrimony/updateFamilyDetails",
	UPDATE_PARTNER_DETAILS : BASE_URL + "/matrimony/updatePartnerDetails",
	UPDATE_NEW_CONTACT_DETAILS : BASE_URL + "/matrimony/updateContactDetails",
	UPDATE_NEW_COST_DETAILS : BASE_URL + "/matrimony/updateCastsDetails",
	UPDATE_NEW_PERSONAL_DETAILS : BASE_URL + "/matrimony/updatePersonalDetails",
	UPDATE_NEW_LIFE_DETAILS : BASE_URL + "/matrimony/updateLifeDetails",
	UPDATE_NEW_APPLICATION_DETAILS : BASE_URL + "/matrimony/updateApplicationDetails",
	NEAREST_BRANCH : BASE_URL + "/matrimony/nearestBranch",
	UPDATE_NEW_EDUCATIONAL_DETAILS : BASE_URL + "/matrimony/updateEducationalDetails",
	UPDATE_NEW_JOB_DETAILS : BASE_URL + "/matrimony/updateJobDetails",
	UPDATE_PERSONAL_CERTIFICATES : BASE_URL + "/matrimony/customer-personal-certificates-upload",
	VISA_TYPES : BASE_URL + "/admin-settings/VisaTyp",
	UPDATE_PROFILE_UPLOAD : BASE_URL + "/matrimony/customer/profile-image-upload",
	UPDATE_IDPROOF_UPLOAD : BASE_URL + "/matrimony/customer/id-image-upload",
	GET_CUSTOMER_VERIFIED_PROFILES : BASE_URL + "/matrimony/get-verified-profiles-list",
	GET_CUSTOMER_SUGGESTED_PROFILES : BASE_URL + "/matrimony/suggested-profiles",
	MATCHED_PARTNER_DETAILS : BASE_URL + "/matrimony/matchedPPartnerDetails",
	ADD_CUSTOMER_FOLLOWUP_DATA : BASE_URL + "/customer/create-customer-follow-up",
	CUSTOMER_FOLLOWUP_DATA : BASE_URL + "/customer/customer-follow-up",
	PREMIUM_PROFILES_DATA : BASE_URL + "/matrimony/premium-profiles",
	AUTO_REVEAL_SETTINGS : BASE_URL + "/matrimony/auto-reveal-settings"


}
